import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Td.css';

const Td = ({ children, className, ...rest }) => (
  <td className={classNames('td', className)} {...rest} >
    { children }
  </td>
);

Td.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Td;



// WEBPACK FOOTER //
// ./src/components/Td/Td.jsx